<template lang="pug">
  
  div(class="home")
   Prompter
 
</template>

<script>
// @ is an alias to /src
import Prompter from "@/components/Prompter.vue"

export default {
  name: "home",
  components: {
    Prompter
  }
}
</script>
